import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["onChange", "defaultCountry"];
import React from 'react';
import 'react-phone-number-input/style.css';
import './style.css';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { Input, Box } from '@chakra-ui/core';
import { CountrySelectWithIcon } from 'react-phone-number-input/modules/CountrySelect';
import { jsx as ___EmotionJSX } from "@emotion/react";
export { isValidPhoneNumber };
var DEFAULT_COUNTRY = 'AU';
var MobileNumberInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$defaultCountry = _ref.defaultCountry,
      defaultCountry = _ref$defaultCountry === void 0 ? DEFAULT_COUNTRY : _ref$defaultCountry,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return ___EmotionJSX(Box, {
    position: "relative",
    pt: "3",
    pb: "3"
  }, ___EmotionJSX(PhoneInput, _extends({
    ref: ref,
    international: true,
    countrySelectComponent: function countrySelectComponent(countrySelectProps) {
      return ___EmotionJSX(Box, {
        pos: "relative",
        zIndex: "2",
        pl: "2"
      }, ___EmotionJSX(CountrySelectWithIcon, countrySelectProps));
    },
    inputComponent: /*#__PURE__*/React.forwardRef(function (inputProps, inputRef) {
      return ___EmotionJSX(Input, _extends({
        ref: inputRef
      }, props, inputProps, {
        position: "absolute",
        pl: "12"
      }));
    }),
    defaultCountry: defaultCountry,
    onChange: onChange
  }, props)));
}); // exported this as a constant aside from default export as a temporary fix
// for jest not being to resolve default imports inside node_modules/hometime-ui

export { MobileNumberInput };
export default MobileNumberInput;